// components/AnimatedNumber.tsx
"use client";
import React, { useEffect } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";

interface AnimatedNumberProps {
	number: number;
	duration?: number; // in seconds
	decimals?: number;
	className?: string;
	prefix?: string;
	suffix?: string;
}

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ number, duration = 1, decimals = 0, className = "", prefix = "", suffix = "" }) => {
	const count = useMotionValue(0);
	const rounded = useTransform(count, (latest) => `${prefix}${latest.toFixed(decimals)}${suffix}`);

	useEffect(() => {
		const controls = animate(count, number, {
			duration,
			ease: "easeOut",
		});
		return controls.stop;
	}, [number, duration, count]);

	return <motion.strong className={className}>{rounded}</motion.strong>;
};

export default AnimatedNumber;
